// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"4dd546f5","112":"7d9db642","479":"227dfc8b","488":"dd42d9f3","989":"779e3aa3"}[chunkId] + ".chunk.js";
};